import { createFileRoute } from "@tanstack/react-router";
import BeyondAntidepressants from "@/pages/BeyondAntidepressants";
export const Route = createFileRoute("/beyond-antidepressants")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Beyond Antidepressants | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "When antidepressants are not enough, SAINT® TMS, SPRAVATO®, and ketamine offer next steps. Explore advanced depression treatment options in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Beyond Antidepressants | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "When antidepressants are not enough, SAINT® TMS, SPRAVATO®, and ketamine offer next steps. Explore advanced depression treatment options in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/beyond-antidepressants",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/beyond-antidepressants",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BeyondAntidepressants />;
}
